import React from 'react';

export default () => (
  <svg viewBox="0 0 81 109" x={-20} y={-52} width={40} height={52}>
    <path
      fill="#a28e81"
      d="M81,40.5C81,72,40.83,109,40.83,109S0,71,0,40.5a40.5,40.5,0,0,1,81,0Z"
    />
    <g transform={`scale(0.7) translate(22 11)`}>
      <path
        fill="white"
        d="M55.3,16C53.9,15.7,44,13.8,35,13.8c-9.2,0-18.9,1.8-20.3,2.1c-4.2,0.1-7.5,3.9-7.5,8.6v38.1
        c0,4.5,3.1,8.3,7.1,8.6v3.9c0,0.4,0.3,0.8,0.7,0.8h7.5c0.4,0,0.7-0.4,0.7-0.8v-3.9h23.6v3.9c0,0.4,0.3,0.8,0.7,0.8h7.5
        c0.4,0,0.7-0.4,0.7-0.8v-3.9c4-0.3,7.2-4,7.2-8.6V24.6C62.8,19.9,59.4,16.1,55.3,16z M21.9,17.9c0-0.4,0.3-0.8,0.7-0.8h24.8
        c0.4,0,0.7,0.3,0.7,0.8v1.7c0,0.4-0.3,0.8-0.7,0.8H22.6c-0.4,0-0.7-0.3-0.7-0.8V17.9z M23.5,61c-1,1.5-9.8,1.2-11.8-0.9
        c-1.2-1.2-1.3-6.3,0-7.4c1.8-1.4,6,2,8.3,3.2C22.4,57.1,24.5,59.4,23.5,61z M44.3,66.9c0,0.6-0.2,1.1-0.5,1.1H26.2
        c-0.3,0-0.5-0.5-0.5-1.1v-2.4c0-0.6,0.2-1.1,0.5-1.1h17.6c0.3,0,0.5,0.5,0.5,1.1V66.9z M35,50.7c-9.1,0-17.6-2.4-24.1-6.7V24.6
        c0-2.5,48.2-2.5,48.2,0V44C52.6,48.3,44.1,50.7,35,50.7z M59.4,60.1c-2,2.1-10.8,2.4-11.8,0.9c-1-1.5,1.1-3.8,3.5-5.1
        c2.3-1.2,6.5-4.6,8.3-3.2C60.7,53.8,60.6,58.8,59.4,60.1z"
      />
      <path
        fill="white"
        d="M4.4,35.5C6,35.8,5.5,40,5.6,41.9c0.1,2.1-0.5,4.5-1.8,4.7c-1.3,0.2-4.5-5-4-7.2C0.1,38,3.2,35.3,4.4,35.5z"
      />
      <path
        fill="white"
        d="M65.4,35.5c-1.6,0.3-1.1,4.5-1.2,6.4c-0.1,2.1,0.5,4.5,1.8,4.7c1.3,0.2,4.5-5,4-7.2
        C69.7,38,66.6,35.3,65.4,35.5z"
      />
    </g>
  </svg>
);


// WEBPACK FOOTER //
// ./src/containers/ProjectMap/components/Bus.js